// 2026 Loveland Sculpture Show
import autumnLeavesSheddingSilence from './images/2026_loveland_show/Autumn_Leaves_Shedding_Silence.jpg'
import awakeningFromWinterDreams from './images/2026_loveland_show/Awakening_From_Winter_Dreams.jpg'
import awakeningFromWinterDreams2 from './images/2026_loveland_show/Awakening_From_Winter_Dreamsview_2.jpg'
import blossomAtTheStreamsEdge from './images/2026_loveland_show/Blossom_at_the_Stream\'s_Edge.jpg'
import branchedInTwilight from './images/2026_loveland_show/Branched_in_Twilight.jpg'
import flutedFlowersVinedInLight from './images/2026_loveland_show/Fluted_Flowers_Vined_in_Light.jpg'
import inYourArmsIRemember from './images/2026_loveland_show/In_Your_Arms_I_Remember.jpg'
import leaf from './images/2026_loveland_show/Leaf.jpg'
import leavesFallThroughTheWindOfTime from './images/2026_loveland_show/Leaves_Fall_Through_the_Wind_of_Time.jpg'
import leavesHiddenInMist from './images/2026_loveland_show/Leaves_Hidden_in_Mist.jpg'
import leavesOpenToRain from './images/2026_loveland_show/Leaves_Open_to_Rain.jpg'
import longing from './images/2026_loveland_show/Longing.jpg'
import quietTheMorningLily from './images/2026_loveland_show/Quiet,_the_Morning_Lily.jpg'
import quietTheMorningLily2 from './images/2026_loveland_show/Quiet,_the_Morning_Lily_View_2.jpg'
import woodlandLiliesOpenAtDawn from './images/2026_loveland_show/Woodland_Lilies_Open_At_Dawn.jpg'
import woodlandLiliesOpenAtDawn2 from './images/2026_loveland_show/Woodland_Lilies_Open_At_Dawn_View_2.jpg'
// 2025 Loveland Sculpture Show
import image0 from './images/2025_loveland_show/2025_image0.png';
import image1 from './images/2025_loveland_show/2025_image1.png';
import image2 from './images/2025_loveland_show/2025_image2.png';
import image3 from './images/2025_loveland_show/2025_image3.png';
import image4 from './images/2025_loveland_show/2025_image4.jpeg';
import image5 from './images/2025_loveland_show/2025_image5.jpeg';
import image6 from './images/2025_loveland_show/2025_image6.jpeg';
import image7 from './images/2025_loveland_show/2025_image7.jpeg';
import image8 from './images/2025_loveland_show/2025_image8.jpeg';
import image9 from './images/2025_loveland_show/2025_image9.jpeg';
import image10 from './images/2025_loveland_show/2025_image10.jpeg';
// photo additions from 3/24/24::
import pyramid_stone_stacks_2 from './images/pyramid_stone_stacks_2.jpeg';
import pyramid_stone_stack_1 from './images/pyramid_stone_stack_1.jpeg';
import sculpture_fest_1 from './images/sculpture_fest_1.jpeg';
import sculpture_fest_2 from './images/sculpture_fest_2.jpeg';
import leaves_1 from './images/leaves_1.jpeg';
import leaves_2 from './images/leaves_2.jpeg';
// original photo list:
import img_4749 from "./images/img_4749.jpg";
import img_4751 from "./images/img_4751.jpg";
import img_4755 from "./images/img_4755.jpg";
import img_4756 from "./images/img_4756.jpg";
import img_4761 from "./images/img_4761.jpg";
import img_4763 from "./images/img_4763.jpg";
import img_4764 from "./images/img_4764.jpg";
import img_4765 from "./images/img_4765.jpg";
import img_4767 from "./images/img_4767.jpg";
import img_4770 from "./images/img_4770.jpg";

export const currentWork = [
  {
    image: autumnLeavesSheddingSilence,
    alt: "botanical sculpture cast in bronze",
    title: "Autumn Leaves Shedding Silence",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: awakeningFromWinterDreams,
    alt: "botanical sculpture cast in bronze",
    title: "Awakening From Winter Dreams",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: awakeningFromWinterDreams2,
    alt: "botanical sculpture cast in bronze",
    title: "Awakening From Winter Dreams (view 2)",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: blossomAtTheStreamsEdge,
    alt: "botanical sculpture cast in bronze",
    title: "Blossom at the Stream's Edge",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: branchedInTwilight,
    alt: "botanical sculpture cast in bronze",
    title: "Branched in Twilight",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: flutedFlowersVinedInLight,
    alt: "botanical sculpture cast in bronze",
    title: "Fluted Flowers Vined in Light",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: inYourArmsIRemember,
    alt: "botanical sculpture cast in bronze",
    title: "In Your Arms I Remember",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: leaf,
    alt: "botanical sculpture cast in bronze",
    title: "Leaf",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: leavesFallThroughTheWindOfTime,
    alt: "botanical sculpture cast in bronze",
    title: "Leaves Fall Through the Wind of Time",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: leavesHiddenInMist,
    alt: "botanical sculpture cast in bronze",
    title: "Leaves Hidden in Mist",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: leavesOpenToRain,
    alt: "botanical sculpture cast in bronze",
    title: "Leaves Open to Rain",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: longing,
    alt: "botanical sculpture cast in bronze",
    title: "Longing",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: quietTheMorningLily,
    alt: "botanical sculpture cast in bronze",
    title: "Quiet, the Morning Lily",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: quietTheMorningLily2,
    alt: "botanical sculpture cast in bronze",
    title: "Quiet, the Morning Lily (view 2)",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: woodlandLiliesOpenAtDawn,
    alt: "botanical sculpture cast in bronze",
    title: "Woodland Lilies Open at Dawn",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  },
  {
    image: woodlandLiliesOpenAtDawn2,
    alt: "botanical sculpture cast in bronze",
    title: "Woodland Lilies Open at Dawn (view 2)",
    description: "Bronze",
    info: "Sculpture in the Park 2026 (Loveland, CO)",
    dimensions: ""
  }
]

export const pastWork = [
  {
    image: image0,
    alt: "floral sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image1,
    alt: "floral sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image2,
    alt: "floral sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image3,
    alt: "botanical sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image4,
    alt: "botanical sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image5,
    alt: "botanical sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image6,
    alt: "botanical sculpture cast in bronze - displayed with a backdrop of cool-toned paint on canvas",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image7,
    alt: "botanical sculpture cast in bronze - displayed with a backdrop of cool-toned paint on canvas",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image8,
    alt: "botanical sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image9,
    alt: "botanical sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  {
    image: image10,
    alt: "botanical sculpture cast in bronze",
    title: "Sculpture in the Park 2025",
    description: "Bronze",
    info: null,
    dimensions: ""
  },
  // added 3/24/24
  {
    image: pyramid_stone_stacks_2,
    alt: "two outdoor sculptures featuring bronze pyramid bases with stacked round stones on top",
    title: "Balanced Stones",
    description: "Steel & Stone",
    info: null,
    dimensions: "2' base | 4' total height"
  },
  {
    image: pyramid_stone_stack_1,
    alt: "outdoor sculpture featuring bronze pyramid base with stacked round stones on top",
    title: "Balanced Stones",
    description: "Steel & Stone",
    info: "Client Setting",
    dimensions: null
  },
  {
    image: sculpture_fest_1,
    alt: "bronze and stone sculptures on display at the 2024 Tucson Sculpture Festival",
    title: "Sculpture Tucson Show",
    description: "Bronze, Steel, & Stone",
    info: "3/14/2024",
    dimensions: null
  },
  {
    image: sculpture_fest_2,
    alt: "bronze and stone sculptures on display at the 2024 Tucson Sculpture Festival",
    title: "Sculpture Tucson Show",
    description: "Bronze, Steel, & Stone",
    info: "3/14/2024",
    dimensions: null
  },
  {
    image: leaves_1,
    alt: "sculpture of a cluster of leaves cast in bronze",
    title: "Leaves Spread Across a Canopy of Dreams",
    description: "Bronze",
    info: null,
    dimensions: null
  },
  {
    image: leaves_2,
    alt: "sculpture of a cluster of leaves cast in bronze",
    title: "Leaves Spread Across a Canopy of Dreams",
    description: "Bronze",
    info: null,
    dimensions: null
  },
  // original photo list...
  {
    image: img_4749,
    alt: "sculpture of a cluster of leaves cast in bronze",
    title: "Waterleaf Gaze",
    description: "Bronze",
    info: null,
    dimensions: "12in x 10in x 6in"
  },
  {
    image: img_4751,
    alt: "botanic sculpture cast in bronze",
    title: "Rivered in Leafshed",
    description: "Bronze",
    info: null,
    dimensions: "14in x 9in x 8in"
  },
  {
    image: img_4755,
    alt: "botanic sculpture cast in bronze",
    title: "Lightfold Returns the Singing Earth",
    description: "Bronze",
    info: null,
    dimensions: "11in x 9in x 8in"
  },
  {
    image: img_4756,
    alt: "sculpture of a cluster of leaves cast in bronze",
    title: "Silence of Dawn",
    description: "Bronze",
    info: null,
    dimensions: "11in x 8in x 1in"
  },
  {
    image: img_4761,
    alt: "sculpture of a leaf cast in bronze",
    title: "A Sea Before You",
    description: "Bronze",
    info: null,
    dimensions: "9in x 3in x 1in"
  },
  {
    image: img_4763,
    alt: "floral sculpture cast in bronze",
    title: "Lilies Dipping Sleep Beneath Moonlight",
    description: "Bronze",
    info: null,
    dimensions: "16in x 7in x 8in"
  },
  {
    image: img_4764,
    alt: "floral sculpture cast in bronze",
    title: "Under the Spell of Stars",
    description: "Bronze",
    info: null,
    dimensions: "11in x 5in x 7in"
  },
  {
    image: img_4765,
    alt: "abstract sculpture cast in bronze",
    title: "Web Adrift in the Sea of Time",
    description: "Bronze",
    info: null,
    dimensions: "12in x 11in x 1in"
  },
  {
    image: img_4767,
    alt: "abstract sculpture cast in bronze",
    title: "Web of Existence",
    description: "Bronze",
    info: null,
    dimensions: "13in x 14in x 4in"
  },
  {
    image: img_4770,
    alt: "abstract sculpture cast in bronze",
    title: "Web of Dreams",
    description: "Bronze",
    info: null,
    dimensions: "5in x 5in"
  },
];
